import { useDispatch } from 'react-redux';

import { Dispatch } from 'store/main';

export const useMainDispatch: () => Dispatch = useDispatch;
